import { render, staticRenderFns } from "./two.vue?vue&type=template&id=28687ea9&scoped=true"
import script from "./two.vue?vue&type=script&lang=js"
export * from "./two.vue?vue&type=script&lang=js"
import style0 from "./two.vue?vue&type=style&index=0&id=28687ea9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28687ea9",
  null
  
)

export default component.exports